import { css } from 'styled-components';

export const guideHtmlRenderTheme = css`
  .guide-html-content,
  .guide-html-render-surface {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .guide-html-content::-webkit-scrollbar,
  .guide-html-render-surface::-webkit-scrollbar {
    height: 6px;
  }

  .guide-html-content::-webkit-scrollbar-thumb,
  .guide-html-render-surface::-webkit-scrollbar-thumb {
    background: rgb(15 23 42 / 12%);
    border-radius: 999px;
  }

  .guide-html-render-surface > style {
    display: none;
  }

  .guide-html-content table,
  .guide-html-render-surface table {
    border-collapse: collapse;
    max-width: none;
  }

  .guide-html-content img,
  .guide-html-content video,
  .guide-html-render-surface img,
  .guide-html-render-surface video {
    max-width: 100%;
    height: auto;
  }

  .guide-html-render-surface .guide-rich-html-scope {
    min-width: 0;
    color: inherit;
    font-family: inherit;
    line-height: 1.65;
  }

  .guide-html-render-surface .guide-rich-html-scope * {
    box-sizing: border-box;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(h1, h2, h3, h4, h5, h6) {
    margin: 0 0 0.85em;
    color: #0f172a;
    line-height: 1.15;
    letter-spacing: -0.03em;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(p, ul, ol, pre, table, blockquote) {
    margin: 0 0 1rem;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(ul, ol) {
    padding-left: 1.35rem;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(li + li) {
    margin-top: 0.35rem;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(a) {
    color: #2563eb;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(hr) {
    margin: 1.25rem 0;
    border: 0;
    border-top: 1px solid #dbe3ee;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(code, pre) {
    font-family: 'Monaco', 'Courier New', monospace;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(pre) {
    overflow-x: auto;
    padding: 0.9rem 1rem;
    border-radius: 12px;
    background: #0f172a;
    color: #f8fafc;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(th, td) {
    border: 1px solid #dbe3ee;
    padding: 10px 12px;
    vertical-align: top;
  }

  .guide-html-render-surface .guide-rich-html-scope :where(blockquote) {
    margin-left: 0;
    padding: 0.9rem 1rem;
    border-left: 4px solid #93c5fd;
    border-radius: 0 12px 12px 0;
    background: #eff6ff;
    color: #1e3a8a;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-doc {
    display: grid;
    gap: 24px;
    color: #0f172a;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-section {
    position: relative;
    overflow: hidden;
    padding: clamp(20px, 2vw, 28px);
    border: 1px solid #e4eaf3;
    border-radius: 24px;
    background: #ffffff;
    box-shadow: 0 16px 36px rgb(15 23 42 / 6%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero {
    color: #ffffff;
    background: linear-gradient(135deg, #132451 0%, #2452bf 54%, #4776df 100%);
    box-shadow: 0 30px 60px rgb(32 63 146 / 24%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero::after {
    content: '';
    position: absolute;
    right: -120px;
    top: 56px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    background: rgb(255 255 255 / 11%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero > * {
    position: relative;
    z-index: 1;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero :where(h1, h2, h3, h4, h5, h6) {
    color: #ffffff;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero h1 {
    margin-bottom: 0.35em;
    font-size: clamp(2.3rem, 1.9rem + 2.2vw, 4.3rem);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-eyebrow {
    display: inline-flex;
    align-items: center;
    min-height: 32px;
    padding: 0 12px;
    border-radius: 999px;
    background: rgb(37 99 235 / 10%);
    color: #335dff;
    font-size: 0.76rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero .guide-eyebrow {
    background: rgb(255 255 255 / 16%);
    color: #ffffff;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-lead {
    max-width: 860px;
    margin-bottom: 0;
    color: #5b6678;
    font-size: clamp(1.05rem, 1rem + 0.35vw, 1.35rem);
    line-height: 1.65;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero .guide-lead {
    color: rgb(255 255 255 / 86%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-chip-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-chip {
    display: inline-flex;
    align-items: center;
    min-height: 36px;
    padding: 0 14px;
    border: 1px solid #d6deea;
    border-radius: 999px;
    background: #ffffff;
    color: #334155;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-hero .guide-chip {
    border-color: rgb(255 255 255 / 18%);
    background: rgb(255 255 255 / 14%);
    color: #ffffff;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-grid {
    display: grid;
    gap: 18px;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-grid--2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-grid--3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-grid--4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-split {
    display: grid;
    gap: 18px;
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.75fr);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-card {
    padding: 20px;
    border: 1px solid #e4eaf3;
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0 12px 26px rgb(15 23 42 / 6%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-card--soft {
    background: linear-gradient(180deg, #fbfdff 0%, #f3f7ff 100%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-card--dark {
    background: #0f172a;
    border-color: #0f172a;
    color: #f8fafc;
    box-shadow: 0 18px 36px rgb(15 23 42 / 18%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-card--dark :where(h1, h2, h3, h4, h5, h6, p, li, strong, span, small) {
    color: inherit;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-stat-label {
    display: inline-flex;
    margin-bottom: 10px;
    color: #335dff;
    font-size: 0.76rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-callout {
    padding: 18px 20px;
    border: 1px solid rgb(37 99 235 / 16%);
    border-radius: 18px;
    background: linear-gradient(135deg, rgb(59 130 246 / 12%), rgb(14 116 144 / 8%));
    color: #0f172a;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-callout :last-child {
    margin-bottom: 0;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-media-frame {
    margin: 0;
    overflow: hidden;
    border: 1px solid #e4eaf3;
    border-radius: 22px;
    background: #f8fafc;
    box-shadow: 0 12px 28px rgb(15 23 42 / 7%);
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-media-frame img,
  .guide-html-render-surface .guide-rich-html-scope .guide-media-frame video {
    display: block;
    width: 100%;
    height: auto;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-caption {
    margin: 0;
    padding: 14px 18px;
    background: #ffffff;
    color: #64748b;
    font-size: 0.92rem;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-placeholder {
    display: grid;
    gap: 8px;
    place-items: center;
    min-height: 180px;
    padding: 24px;
    border: 1px dashed #cbd5e1;
    border-radius: 18px;
    background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
    color: #475569;
    text-align: center;
    font-weight: 700;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-placeholder small {
    color: #64748b;
    font-size: 0.9rem;
    font-weight: 500;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-muted {
    color: #64748b;
  }

  .guide-html-render-surface .guide-rich-html-scope .guide-table-wrap {
    overflow-x: auto;
  }

  @media (max-width: 960px) {
    .guide-html-render-surface .guide-rich-html-scope .guide-grid--4,
    .guide-html-render-surface .guide-rich-html-scope .guide-grid--3,
    .guide-html-render-surface .guide-rich-html-scope .guide-grid--2,
    .guide-html-render-surface .guide-rich-html-scope .guide-split {
      grid-template-columns: 1fr;
    }

    .guide-html-render-surface .guide-rich-html-scope .guide-hero::after {
      width: 280px;
      height: 280px;
      right: -90px;
      top: 120px;
    }
  }
`;
